import React from 'react';
import i18next from 'i18next';

function RenderCompanies({ companies, metaData }) {
  return (
    <div>
      {companies &&
        companies.map((val, key) => {
          let newLink = `${window.location.origin}/${i18next.language === 'es' ? val[2] : val[1]}`;
          return (
            <a href={newLink} target="_blank">
              {val[0]} {key === companies.length - 1 ? '' : ' | '}
            </a>
          );
        })}
    </div>
  );
}

export default RenderCompanies;



// WEBPACK FOOTER //
// ./src/features/home/BusCompanies/RenderCompanies/RenderCompanies.js